import React from 'react';
import './App.css';
import GameContainer from './app/gameContainer';

function App() {
  return (
    <div className="App">
      <GameContainer />
    </div>
  );
}

export default App;
